class CartDrawer extends Theme.Component {
  constructor() {
    super();
  }

  connectedCallback() {
    super.connectedCallback();

    document.addEventListener("addtocart", (event) => {
      this.render().then(() => this.show());
    });

    document.addEventListener("cartlink:click", (event) => {
      this.show();
    });

    if (Theme.URLParams.has("cart")) {
      this.show();
    }
  }

  show() {
    document.dispatchEvent(new CustomEvent("cartdrawer:show"));

    setTimeout(() => {
      this.classList.add("state--active");
    }, 50);
  }

  hide() {
    this.classList.remove("state--active");
  }

  changeSubscription(item, element) {
    this.change({
      id: item.key,
      quantity: item.quantity,
      selling_plan: element.value
    });
  }

  changeIntoSubscription(item) {
    const data = {
      "items": [item]
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(data)
    })
    .then((response) => response.json())
    .then(() => {
      this.change({ id: item.key, quantity: 0 });
    });
  }

  change(data) {
    return fetch("/cart/change.js", {
      method: "POST",
      headers: {
        'Content-Type': "application/json"
      },
      body: JSON.stringify(data)
    })
    .then((response) => response.json())
    .then((data) => {
      document.dispatchEvent(new CustomEvent("cart:change", {
        detail: data
      }));

      this.render();
    });
  }

  render() {
    const current_content = document.getElementById("cart");

    function get_new_content(response) {
      const string = JSON.parse(response)["cart-drawer"];
      const parser = new DOMParser();
      const doc = parser.parseFromString(string, "text/html");

      return doc.getElementById("cart");
    }

    return fetch("/?sections=cart-drawer")
      .then((response) => response.text())
      .then((response) => {
        current_content.replaceWith(get_new_content(response));
      })
      .then(() => super.connectedCallback());
  }
}

customElements.define("cart-drawer", CartDrawer);
